import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Form, useLoaderData, useNavigate } from 'react-router-dom';
import ServicesError from '../../components/ServicesError';
import { useApplicationStore } from '../../stores/applicationStore';
import { useUserStore } from '../../stores/userStore';
import ServiceCard from './components/ServiceCard';

export async function loader({ request }) {
	const url = new URL(request.url);
	const zipCode = url.searchParams.get('zipCode');
	const county = url.searchParams.get('county');
	const taxonomyCode = url.searchParams.get('taxonomy[taxonomy_code]');
	const taxonomyName = url.searchParams.get(
		'taxonomy[taxonomy_name_reference]',
	);
	useUserStore.getState().verifyUser();
	// taxonomyCode/taxonomyName stay local to this page; only zipCode and the
	// eventually-chosen program are carried across pages now.
	useApplicationStore.getState().setZipCode(zipCode);
	return { zipCode, taxonomyCode, taxonomyName, county };
}

const AvailableOrganizations = () => {
	const { zipCode, taxonomyCode, taxonomyName, county } = useLoaderData();
	const navigate = useNavigate();
	const { setProgram } = useApplicationStore();
	const {
		data: programs,
		isLoading,
		isError,
		refetch,
	} = useQuery({
		queryKey: ['organizations', zipCode, taxonomyCode, county],
		queryFn: async () => {
			const { data } = await axios.get(
				'/clients/getServicesByTaxonomyAndPostalCode',
				{ params: { zipCode, taxonomyCode, county } },
			);
			return data;
		},
	});

	const handleSubmit = ({ nativeEvent }) => {
		const programId = nativeEvent.submitter.value;
		const program = programs.find((p) => p.id == programId);
		setProgram(program);
	};

	return (
		<div className="page available-organizations">
			<div className="sm:mx-auto sm:w-full sm:max-w-2xl">
				<h2>
					Organizations <small>{zipCode}</small>
				</h2>
			</div>
			<div className="sm:mx-auto sm:w-full sm:max-w-2xl">
				<Form method="get" action="/checkProfile" onSubmit={handleSubmit}>
					<h3>{taxonomyName}</h3>
					{isLoading && (
						<div className="text-center">
							<span className="loading loading-dots loading-lg text-primary"></span>
						</div>
					)}
					{isError && <ServicesError onRetry={refetch} />}
					{!isLoading && !isError && programs.length === 0 && (
						<div>
							<p>No organizations found. Please try another search.</p>
							<button
								type="button"
								className="btn btn-primary btn-sm btn-block"
								onClick={() => navigate(-1)}
							>
								Go Back
							</button>
						</div>
					)}
					{!isLoading &&
						!isError &&
						programs.map((program) => (
							<ServiceCard key={program.id} program={program} />
						))}
					<input type="hidden" name="zipCode" value={zipCode} />
					<input
						type="hidden"
						name="taxonomy[taxonomy_code]"
						value={taxonomyCode}
					/>
					<input
						type="hidden"
						name="taxonomy[taxonomy_name_reference]"
						value={taxonomyName}
					/>
				</Form>
			</div>
		</div>
	);
};

export default AvailableOrganizations;
